import React, { useState } from 'react';

function NotificationsPage() {
  const [notifications, setNotifications] = useState({
    email: {
      marketing: true,
      updates: true,
      security: true,
      newsletter: false
    },
    push: {
      newMessages: true,
      mentions: true,
      reminders: false
    },
    frequency: 'daily'
  });

  const handleToggle = (category, setting) => {
    setNotifications({
      ...notifications,
      [category]: {
        ...notifications[category],
        [setting]: !notifications[category][setting]
      }
    });
  };

  const handleFrequencyChange = (e) => {
    setNotifications({
      ...notifications,
      frequency: e.target.value
    });
  };
  return (
    <>
      <div className="account-header">
        <h2>Notification Preferences</h2>
      </div>

      <div className="notification-section">
        <h3>Email Notifications</h3>
        <div className="notification-options">
          <div className="notification-option">
            <div className="option-info">
              <h4>Marketing emails</h4>
              <p>Receive emails about new features, promotions, and special offers</p>
            </div>
            <label className="toggle-switch">
              <input
                type="checkbox"
                checked={notifications.email.marketing}
                onChange={() => handleToggle('email', 'marketing')}
              />
              <span className="toggle-slider"></span>
            </label>
          </div>

          <div className="notification-option">
            <div className="option-info">
              <h4>Product updates</h4>
              <p>Receive emails about product updates and new features</p>
            </div>
            <label className="toggle-switch">
              <input
                type="checkbox"
                checked={notifications.email.updates}
                onChange={() => handleToggle('email', 'updates')}
              />
              <span className="toggle-slider"></span>
            </label>
          </div>
         <div className="notification-option">
            <div className="option-info">
              <h4>Security alerts</h4>
              <p>Receive emails about security updates and account activity</p>
            </div>
            <label className="toggle-switch">
              <input
                type="checkbox"
                checked={notifications.email.security}
                onChange={() => handleToggle('email', 'security')}
              />
              <span className="toggle-slider"></span>
            </label>
          </div>

          <div className="notification-option">
            <div className="option-info">
              <h4>Newsletter</h4>
              <p>Receive our monthly newsletter with tips and industry news</p>
            </div>
            <label className="toggle-switch">
              <input
                type="checkbox"
                checked={notifications.email.newsletter}
                onChange={() => handleToggle('email', 'newsletter')}
              />
              <span className="toggle-slider"></span>
            </label>
          </div>
        </div>
      </div>
      <div className="notification-section">
        <h3>Push Notifications</h3>
        <div className="notification-options">
          <div className="notification-option">
            <div className="option-info">
              <h4>New messages</h4>
              <p>Receive notifications when you get new messages</p>
            </div>
            <label className="toggle-switch">
              <input
                type="checkbox"
                checked={notifications.push.newMessages}
                onChange={() => handleToggle('push', 'newMessages')}
              />
              <span className="toggle-slider"></span>
            </label>
          </div>

          <div className="notification-option">
            <div className="option-info">
              <h4>Mentions</h4>
              <p>Receive notifications when you are mentioned in comments</p>
            </div>
            <label className="toggle-switch">
              <input
                type="checkbox"
                checked={notifications.push.mentions}
                onChange={() => handleToggle('push', 'mentions')}
              />
              <span className="toggle-slider"></span>
            </label>
          </div>

          <div className="notification-option">
            <div className="option-info">
              <h4>Reminders</h4>
              <p>Receive notifications for upcoming events and tasks</p>
            </div>
            <label className="toggle-switch">
              <input
                type="checkbox"
                checked={notifications.push.reminders}
                onChange={() => handleToggle('push', 'reminders')}
              />
              <span className="toggle-slider"></span>
            </label>
          </div>
        </div>
      </div>
      <div className="notification-section">
        <h3>Notification Frequency</h3>
        <div className="frequency-options">
          <div className="form-group radio-group">
            <label>
              <input
                type="radio"
                name="frequency"
                value="realtime"
                checked={notifications.frequency === 'realtime'}
                onChange={handleFrequencyChange}
              />
              <span>Real-time</span>
              <p className="option-description">Receive notifications as they happen</p>
            </label>
          </div>

          <div className="form-group radio-group">
            <label>
              <input
                type="radio"
                name="frequency"
                value="daily"
                checked={notifications.frequency === 'daily'}
                onChange={handleFrequencyChange}
              />
              <span>Daily digest</span>
              <p className="option-description">Receive a daily summary of all notifications</p>
            </label>
          </div>

          <div className="form-group radio-group">
            <label>
              <input
                type="radio"
                name="frequency"
                value="weekly"
                checked={notifications.frequency === 'weekly'}
                onChange={handleFrequencyChange}
              />
              <span>Weekly digest</span>
              <p className="option-description">Receive a weekly summary of all notifications</p>
            </label>
          </div>
        </div>
      </div>

      <div className="notification-actions">
        <button className="secondary-button">Reset to Default</button>
        <button className="danger-button">Unsubscribe from All</button>
      </div>
    </>
  );
}

export default NotificationsPage;
